import PageNotFoundPage from "./page-not-found.page"
export default PageNotFoundPage;
